import React from "react";
import EmployeeContributionStep from "../EmployeeContributions";
import BeneficiaryContributionStep from "../BeneficiaryContributions";

interface ContributionStepsProps {
  currentStep: number;
  isUserEnrolled?: boolean;
  onNext: () => void;
  onPrevious: () => void;
  isSubmitting: boolean;
}

const ContributionSteps: React.FC<ContributionStepsProps> = ({
  currentStep,
  isUserEnrolled,
  onNext,
  onPrevious,
}) => {
  switch (currentStep) {
    case 1:
      return (
        <EmployeeContributionStep
          isUserEnrolled={isUserEnrolled}
          onPrevious={onPrevious}
        />
      );
    case 2:
      return (
        <BeneficiaryContributionStep
          isUserEnrolled={isUserEnrolled}
          onNext={onNext}
        />
      );
    default:
      return null;
  }
};

export default ContributionSteps;
